import React from "react";
export function useInView(options?: IntersectionObserverInit) {
  const ref = React.useRef<Element | null>(null);
  const [inView, setInView] = React.useState(false);
  const optionsRef = React.useRef(options);
  React.useEffect(() => {
    const el = ref.current;
    if (!el || inView) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry?.isIntersecting) {
        setInView(true);
        observer.disconnect();
      }
    }, {
      rootMargin: "200px 0px",
      ...optionsRef.current
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [inView]);
  return [ref, inView] as const;
}